import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/faqs").then(({ data }) => setFaqs(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="faq-page">
      <section className="pt-24 md:pt-32 pb-16 max-w-4xl mx-auto px-6 md:px-10">
        <div className="overline text-[color:var(--ek-accent)] mb-4">SSS</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight leading-[0.95] mb-4">
          Sık sorulan sorular.
        </h1>
        <p className="text-lg text-neutral-500">
          Ehliyet, MYK ve operatörlük süreçleriyle ilgili merak ettikleriniz.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 pb-24">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={f.id} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-display text-lg md:text-xl">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-700 text-base leading-relaxed">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
